export default "__VITE_ASSET__BIIp4diI__"